import React from 'react';
import { default as ToolkitTotaliser } from '@jg/totaliser';
import { isMobileUserAgent } from 'src/helpers/browser';

interface Props {
  percentage: number;
  requestedSize?: 'small' | 'medium' | 'medium-large' | 'large';
}

const Totaliser: React.StatelessComponent<Props> = ({
  percentage,
  requestedSize,
}) => {
  const size = requestedSize
    ? requestedSize
    : isMobileUserAgent()
      ? 'medium'
      : 'large';

  return (
    <div className="jg-center-block">
      <ToolkitTotaliser percent={percentage} size={size} />
    </div>
  );
};

export default Totaliser;



// WEBPACK FOOTER //
// ./src/components/Totaliser/Totaliser.tsx